export default "__VITE_ASSET__unYI24wz__"